export default __webpack_public_path__ + "static/fonts/PFBagueSansPro-Black-6KRI7V7K.woff2!static";